<template>
    <div class="p-1">
        <p class="text-sm text-secondary mb-3">
            <strong>{{ usuario.email }}</strong> dejará de ser <strong>{{ rol.nombre }}</strong>
            y perderá el acceso de administrador de la plataforma. Elige el rol con el que se queda:
            un usuario sin rol no puede iniciar sesión.
        </p>

        <label for="nuevoRol" class="form-label fw-semibold text-xs">Nuevo rol</label>
        <div v-if="cargando" class="text-muted small py-2">
            <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
            Cargando roles...
        </div>
        <select v-else id="nuevoRol" v-model="nuevoRoleId" class="form-select form-select-sm">
            <option :value="null" disabled>Selecciona un rol</option>
            <option v-for="r in roles" :key="r.id" :value="r.id">{{ r.nombre }}</option>
        </select>

        <div v-if="errorMsg" class="alert alert-danger py-2 px-3 text-sm mt-3 mb-0">{{ errorMsg }}</div>

        <div class="d-flex gap-2 justify-content-end mt-3 pt-3 border-top">
            <soft-button variant="outline" color="secondary" size="sm" @click="$emit('close')">
                Cancelar
            </soft-button>
            <soft-button
                variant="gradient"
                color="danger"
                size="sm"
                :loading="guardando"
                :disabled="!nuevoRoleId"
                @click="quitar"
            >
                <i class="fas fa-user-minus me-1"></i>
                Quitar acceso
            </soft-button>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import SoftButton from '@/components/SoftButton.vue';
import { mensajeError } from '@/store/plataformaStore';

export default {
    name: 'QuitarUsuarioModal',
    components: { SoftButton },
    props: {
        rol: { type: Object, required: true },
        usuario: { type: Object, required: true }
    },
    emits: ['close', 'quitado'],
    setup(props, { emit }) {
        const store = useStore();

        const roles = ref([]);
        const nuevoRoleId = ref(null);
        const cargando = ref(true);
        const guardando = ref(false);
        const errorMsg = ref(null);

        store.dispatch('appPlataforma/getRolesNoPlataformaAction')
            .then((data) => {
                roles.value = data;
            })
            .catch((error) => {
                errorMsg.value = mensajeError(error, 'Error al cargar los roles');
            })
            .finally(() => {
                cargando.value = false;
            });

        const quitar = async () => {
            guardando.value = true;
            errorMsg.value = null;
            try {
                await store.dispatch('appPlataforma/quitarUsuarioAction', {
                    roleId: props.rol.id,
                    userId: props.usuario.id,
                    nuevoRoleId: nuevoRoleId.value,
                });
                emit('quitado', `${props.usuario.email} ya no es admin de la plataforma`);
            } catch (error) {
                errorMsg.value = mensajeError(error, 'No se pudo quitar el acceso');
            } finally {
                guardando.value = false;
            }
        };

        return { roles, nuevoRoleId, cargando, guardando, errorMsg, quitar };
    }
};
</script>
